import { render } from "./HeroiconsSolidBadgeCheck.vue?vue&type=template&id=72d7d4d7"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBadgeCheck.vue"]])

export default __exports__